// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"360":"33be9337","453":"3b138222"}[chunkId] + ".chunk.js";
};